<!--
 * @Description:
 * @Author: yeqing
 * @Date: 2022-05-12 16:39:14
 * @LastEditTime: 2022-05-12 18:58:27
 * @LastEditors: yeqing
-->
<template>
  <div class="selectCity" v-if="isShow">
    <a-icon type="close" class="close-icon" @click="onClose" />
    <div class="title">请选择您要测评的专精特新中小企业所在城市</div>
    <div class="btn-box">
      <div @click="onEntrance('beijing')">
        <svg-icon
          icon-class="beijing"
          class="icon1"

        ></svg-icon
        >北京
      </div>
      <div @click="onEntrance('hainan')">
        <svg-icon
          icon-class="hainan"
          class="icon2"
        ></svg-icon
        >海南
      </div>
    </div>
    <div class="desc">其他城市陆续开通中，请耐心等待～</div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: Boolean,
  },
  methods: {
    onEntrance(name) {
      name == "hainan"
        ? this.$router.push("/enterpriseSpecial/smEvaluation?city=Hainan")
        : this.$router.push("/enterpriseSpecial/smEvaluation");
      this.$emit("onClose");
    },
    onClose() {
      this.$emit("onClose");
    },
  },
};
</script>
<style lang="less" scoped>
.selectCity {
  width: 470px;
  height: 190px;
  background: #ffffff;
  box-shadow: 0px 4px 14px 1px rgba(110, 167, 237, 0.24);
  border: 1px solid #cae3ff;
  padding: 24px;
  background: #fff;
  position: relative;
  .close-icon {
    position: absolute;
    right: 12px;
    top: 15px;
    color: #aaa;
    cursor: pointer;
  }
  .title {
    width: 320px;
    height: 16px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 16px;
  }
  .btn-box {
    display: flex;
    div {
      width: 170px;
      height: 44px;
      border-radius: 4px;
      border: 1px solid #eeeeee;
      // line-height: 44px;
      text-align: center;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        border: 1px solid #0072f7;
        color: #0072f7;
      }
    }
    .icon1 {
      width: 24px;
      height: 20px;
      margin-right: 6px;
    }
    .icon2 {
      width: 14px;
      height: 20px;
      margin-right: 6px;
    }
    margin-top: 24px;
  }
  .desc {
    width: 224px;
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(170, 170, 170, 0.85);
    line-height: 14px;
    margin-top: 20px;
  }
  &::after {
    position: absolute;
    top: -7px;
    left: 130px;
    content: "";
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #fff;
    filter: drop-shadow( 0px 4px 14px 1px rgba(110, 167, 237, 0.24));
  }
}
</style>
